
namespace Gamification.Gamification {
    export class ProdottiColumns {
        static columnsKey = 'Gamification.Prodotti';
    }
}